import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { SwiperModule } from 'swiper/angular';

import { SafeHtml } from './pipes/safe-html';
import { Copyright } from './pipes/copyright';

// import { ShareIconsModule } from '@ngx-sharebuttons/icons';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';

import { BottomMenuComponent } from './components/bottom-menu/bottom-menu';
import { CardComponent } from './components/card/card';
import { AudioplayerComponent } from './components/audioplayer/audioplayer';
import { BetaVersionComponent } from './components/beta-version/beta-version';
import { CarouselComponent } from './components/carousel/carousel';
import { CookieInfoComponent } from './components/cookie-info/cookie-info';
import { DetailHeaderComponent } from './components/detailheader/detailheader';
import { FavoriteButtonComponent } from './components/favorite-button/favorite-button.component';
import { HeaderComponent } from './components/header/header';
import { InfoPopupComponent } from './components/infopopup/infopopup';
import { NavHeaderComponent } from './components/navheader/navheader';
import { OnePerWeekComponent } from './components/one-per-week/one-per-week';
import { PartagerButtonComponent } from './components/partager-button/partager-button.component';
import { PopUpComponent } from './components/pop-up/pop-up';
import { SearchCardComponent } from './components/search-card/search-card';
import { SmartAppBannerComponent } from './components/smart-app-banner/smart-app-banner';
import { TranslateModule } from '@ngx-translate/core';
import { DecodeHtmlEntitiesPipe } from './pipes/decode-html-entities/decode-html-entities';
import { TexttrimPipe } from './pipes/texttrim/texttrim';
import { TitleComponent } from './components/title/title';
import { FilterComponent } from './components/filter/filter';
import { TimelineDateComponent } from './components/timeline-date/timeline-date';
import { NewspaperPdfComponent } from './components/newspaper-pdf/newspaper-pdf';
import { DateComponent } from './components/timeline-date/date/date';

const declarations = [
  SafeHtml,
  Copyright,
  DecodeHtmlEntitiesPipe,
  TexttrimPipe,
  CardComponent,
  AudioplayerComponent,
  BetaVersionComponent,
  BottomMenuComponent,
  CarouselComponent,
  CookieInfoComponent,
  DetailHeaderComponent,
  FavoriteButtonComponent,
  HeaderComponent,
  InfoPopupComponent,
  OnePerWeekComponent,
  PartagerButtonComponent,
  PopUpComponent,
  SearchCardComponent,
  SmartAppBannerComponent,
  HeaderComponent,
  NavHeaderComponent,
  TitleComponent,
  FilterComponent,
  TimelineDateComponent,
  DateComponent,
  NewspaperPdfComponent
];


@NgModule({
  declarations,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    IonicModule,
    ShareButtonsModule,
    ShareIconsModule,
    SwiperModule
  ],
  exports:[
    TranslateModule,
    ShareButtonsModule,
    ShareIconsModule,
    SwiperModule,
   ...declarations
  ]
})
export class SharedModule {}
